<template>
  <div class="carousel" v-if="marts.length > 0">
    <h4 class="carousel_title">
      {{ title }}
    </h4>
    <div class="carousel_stage">
      <carousel ref="carousel" :perPage="5" :mouseDrag="false" :navigationEnabled="true" :paginationEnabled="false">
        <slide v-for="(mart, index) in marts" :key="index">
          <slider-item :mart="mart"></slider-item>
        </slide>
      </carousel>
      <div v-if="isMoreThanPerPage" class="carousel_ctrl :prev" @click.prevent="prevSlide"></div>
      <div v-if="isMoreThanPerPage" class="carousel_ctrl :next" @click.prevent="nextSlide"></div>
    </div>
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';
import sliderItem from '@/components/desktop/slider/slider-item.vue';

const components = {
  Carousel,
  Slide,
  sliderItem,
};

const props = {
  title: String,
  marts: Array,
  prefix: String,
};

const computed = {
  isMoreThanPerPage() {
    return this.marts.length > 5;
  },
};

const methods = {
  // ref: https://github.com/SSENSE/vue-carousel/issues/88#issuecomment-370428489
  prevSlide() {
    this.$refs.carousel.goToPage(this.$refs.carousel.getPreviousPage());
  },
  nextSlide() {
    this.$refs.carousel.goToPage(this.$refs.carousel.getNextPage());
  },
};

export default {
  name: 'slider',
  props,
  components,
  computed,
  methods,
};
</script>
